export const MAX_KEYWORD_SELECTED = 1000

// upload all columns, supplier columns, supplier detail columns
export const defaultUploadAllVendorColumns = [
  {
    name: 'fullAddress',
    label: 'Full Address',
    dataType: 'string',
    suggest: true,
    aryMatches: [
      'fullAddress', 'Full Address', 'Full Add', 'fullAdd'
    ]
  },
  {
    name: 'masterId',
    label: 'Master Id',
    // dataType: 'number',
    dataType: 'integer',
    editable: false,
    suggest: true,
    aryMatches: [
      'Master', 'Master Id', 'Master-Id',
    ]
  },
  {
    name: 'companyId',
    label: 'Company Id',
    dataType: 'string',
    suggest: true,
    editable: false,
    aryMatches: [
      'CompanyId', 'Company Id'
    ]
  },
  {
    name: 'erpVendorId',
    label: 'ERP Vendor ID',
    dataType: 'string',
    suggest: true,
    editable: true,
  },
  {
    name: 'suppliername',
    label: 'Supplier Name',
    required: true,
    dataType: 'string',
    editable: true,
    suggest: true,
    aryMatches: [
      'Supplier', 'Supplier Name', 'Company Name', 'Name', 'Vendor', 'Vendor Name'
    ]
  },
  {
    name: 'address1',
    label: 'General Address Line 1',
    required: true,
    dataType: 'string',
    editable: true,
    suggest: true,
    aryMatches: [
      'Address', 'Address Line', 'Address1', 'Address 1', 'Address Line 1', 'Street', 'AD1', 'AD 1',
    ],
  },
  {
    name: 'address2',
    label: 'General Address Line 2',
    dataType: 'string',
    editable: true,
    suggest: true,
    aryMatches: [
      'Address', 'Address Line', 'Address2', 'Address 2', 'Address Line 2', 'Street', 'AD2', 'AD 2',
    ]
  },
  {
    name: 'city',
    label: 'General City',
    required: true,
    dataType: 'string',
    editable: true,
    suggest: true,
  },
  {
    name: 'state',
    label: 'General State',
    required: true,
    dataType: 'string',
    editable: true,
    suggest: true,
    aryMatches: [
      'State/Prov', 'State'
    ]
  },
  {
    name: 'zip',
    label: 'General Zip',
    required: true,
    dataType: 'string',
    suggest: true,
    editable: true,
    aryMatches: [
      'Zip', 'Zip Code', 'Postal Code'
    ]
  },
  {
    name: 'country',
    label: 'General Country',
    dataType: 'string',
    editable: true,
    suggest: true,
    aryMatches: [
      'Country'
    ]
  },
  {
    name: 'phone',
    label: 'General Contact Phone',
    suggest: true,
    dataType: 'string',
    editable: true,
    aryMatches: [
      'Phone', 'Phone Number', 'Mobile', 'Mobile Number'
    ]
  },
  {
    name: 'fax',
    label: 'Fax',
    dataType: 'string',
    editable: true,
    suggest: true,
  },
  {
    name: 'email',
    label: 'General Contact Email',
    suggest: true,
    dataType: 'email',
    editable: true,
    aryMatches: [
      'E-Mail Address', 'Email', 'E-Mail'
    ]
  },
  {
    name: 'url',
    label: 'General Supplier Info Url',
    suggest: true,
    dataType: 'url',
    editable: true,
    aryMatches: [
      'Website', 'Url'
    ]
  },
  {
    name: 'spend',
    label: 'Spend',
    dataType: 'number',
    editable: true,
  },
  {
    name: 'annualizedSpend',
    label: 'Annual Vendor Spend',
    dataType: 'number',
    ignore: true,
    editable: false,
  },
  {
    name: 'contactDate',
    label: 'Contacted Date',
    // dataType: 'string',
    dataType: 'date',
    editable: true,
    suggest: true,
  },
  {
    name: 'contactNameOld',
    label: 'Contact Name',
    dataType: 'string',
    editable: true,
  },
  {
    name: 'isOnlyAcceptCardAsPos',
    label: 'Only Accepts Card as POS',
    dataType: 'boolean',
    editable: true,
  },
  {
    name: 'isAcceptAmericanExpress',
    label: 'Accepts American Express',
    dataType: 'boolean',
    editable: true,
    type: 'threestate'
  },
  {
    name: 'isAcceptMasterCard',
    label: 'Accepts Mastercard',
    dataType: 'boolean',
    editable: true,
    type: 'threestate'
  },
  {
    name: 'isAcceptVisa',
    label: 'Accepts Visa',
    dataType: 'boolean',
    editable: true,
    type: 'threestate'
  },
  {
    name: 'isAcceptCardPaymentByEmail',
    label: 'Accepts Card Payment by Email',
    dataType: 'boolean',
    editable: true,
  },
  {
    name: 'isAcceptCardPaymentByFax',
    label: 'Accepts Card Payment by Fax',
    dataType: 'boolean',
    editable: true,
  },
  {
    name: 'isAcceptCardPaymentByPhone',
    label: 'Accepts Card Payment by Phone',
    dataType: 'boolean',
    editable: true,
  },
  {
    name: 'isAcceptCardPaymentByOnlinePortal',
    label: 'Accepts Card Payment by Online Portal',
    dataType: 'boolean',
    editable: true,
  },
  {
    name: 'americanExpressMinPaymnet',
    label: 'Amex Min Payment',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Amex Min Payment', 'Amex Minimum Payment', 'AmexMinPayment', 'AmexMinimumPayment', 'American Express Min Payment', 'American Express Minimum Payment', 'AmericanExpressMinPayment', 'AmericanExpressMinimumPayment'
    ]
  },
  {
    name: 'americanExpressMaxPayment',
    label: 'Amex Max Payment',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Amex Max Payment', 'Amex Maximum Payment', 'AmexMaxPayment', 'AmexMaximumPayment', 'American Express Max Payment', 'American Express Maximum Payment', 'AmericanExpressMaxPayment', 'AmericanExpressMaximumPayment'
    ]
  },
  {
    name: 'amexIncrementalPaymentAmount',
    label: 'Amex Incremental Payment',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Amex Inc Payment', 'Amex Incremental Payment', 'AmexIncPayment', 'AmexIncrementalPayment', 'American Express Inc Payment', 'American Express Incremental Payment', 'AmericanExpressIncPayment', 'AmericanExpressIncrementalPayment'
    ]
  },
  {
    name: 'mastercardMinPayment',
    label: 'Mastercard Min Payment',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Mastercard Min Payment', 'Mastercard Minimum Payment', 'MastercardMinPayment', 'MastercardMinimumPayment'
    ]
  },
  {
    name: 'mastercardMaxPayment',
    label: 'Mastercard Max Payment',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Mastercard Max Payment', 'Mastercard Maximum Payment', 'MastercardMaxPayment', 'MastercardMaximumPayment'
    ]
  },
  {
    name: 'mastercardIncrementalPaymentAmount',
    label: 'Mastercard Incremental Payment',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Mastercard Inc Payment', 'Mastercard Incremental Payment', 'MastercardIncPayment', 'MastercardIncrementalPayment'
    ]
  },
  {
    name: 'visaMinPayment',
    label: 'Visa Min Payment',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Visa Min Payment', 'Visa Minimum Payment', 'VisaMinPayment', 'VisaMinimumPayment'
    ]
  },
  {
    name: 'visaMaxPayment',
    label: 'Visa Max Payment',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Visa Max Payment', 'Visa Maximum Payment', 'VisaMaxPayment', 'VisaMaximumPayment'
    ]
  },
  {
    name: 'visaIncrementalPaymentAmount',
    label: 'Visa Incremental Payment',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Visa Inc Payment', 'Visa Incremental Payment', 'VisaIncPayment', 'VisaIncrementalPayment'
    ]
  },
  {
    name: 'currentPaymentMethod',
    label: 'Current Payment Method',
    dataType: 'string',
    editable: true,
  },
  {
    name: 'bankAccountNumber',
    label: 'Bank Account Number',
    dataType: 'digit',
    lengthNotGreater: 17,
    editable: true,
  },
  {
    name: 'bankRoutingNumber',
    label: 'Bank Routing Number',
    dataType: 'digit',
    length: 9,
    editable: true,
  },
  {
    name: 'cardAcceptanceNotes',
    label: 'Card Acceptance Notes',
    dataType: 'string',
    editable: true,
  },
  {
    name: 'tokenType',
    label: 'Token Type',
    dataType: 'string',
    editable: true,
  },
  {
    name: 'merchantCategoryCode',
    label: 'Merchant Category Code',
    dataType: 'string',
    editable: true,
  },
  {
    name: 'merchantNumber',
    label: 'Merchant Number',
    dataType: 'string',
    editable: true,
  },
  {
    name: 'merchantName',
    label: 'Merchant Name',
    dataType: 'string',
    editable: true,
  },
  {
    name: 'merchantCity',
    label: 'Merchant City',
    dataType: 'string',
    editable: true,
  },
  {
    name: 'merchantState',
    label: 'Merchant State',
    dataType: 'string',
    editable: true,
  },
  {
    name: 'merchantCountry',
    label: 'Merchant Country',
    dataType: 'string',
    editable: true,
  },
  {
    name: 'merchantZip',
    label: 'Merchant Zip',
    dataType: 'string',
    editable: true,
  },
  {
    name: 'taxId',
    label: 'Tax Id',
    dataType: 'string',
    editable: true,
  },
  {
    name: 'sic',
    label: 'SIC Code',
    dataType: 'string',
    suggest: true,
    editable: true,
    aryMatches: [
      'SIC'
    ]
  },
  {
    name: 'naics',
    label: 'NAICS',
    dataType: 'string',
    suggest: true,
    editable: true,
    aryMatches: [
      'NAICS'
    ]
  },
  {
    name: 'autoCreateMaster',
    label: 'Auto Create Master',
    dataType: 'boolean',
  },
  {
    name: 'cardPaymentByPhoneValue',
    label: 'Card Acceptance Phone',
    dataType: 'string',
    editable: true,
    suggest: true,
    aryMatches: [
      'Card Acceptance Phone', 'cardPhone', 'cardPhoneValue', 'CardAcceptancePhone', 'cardPaymentByPhoneValue', 'Card Phone Value', 'Card Phone'
    ]
  },
  {
    name: 'cardPaymentByFaxValue',
    label: 'Card Acceptance Fax',
    dataType: 'string',
    editable: true,
    suggest: true,
    aryMatches: [
      'Card Acceptance Fax', 'cardFax', 'cardFaxValue', 'CardAcceptanceFax', 'cardPaymentByFaxValue', 'Card Fax Value', 'Card Fax'
    ]
  },
  {
    name: 'cardEmail',
    label: 'Card Acceptance Email',
    dataType: 'string',
    editable: true,
    suggest: true,
    aryMatches: [
      'Card Acceptance Email', 'cardEmail', 'cardEmailValue', 'CardAcceptanceEmail', 'cardPaymentByEmailValue', 'Card Email'
    ]
  },
  {
    name: 'employerIdNumber',
    label: 'Employer Id Number',
    dataType: 'string',
    suggest: true,
    editable: true,
    aryMatches: [
      'Employer Id Number', 'Employer Id', 'EmployerIdNumber', 'EmployerId', 'EIN'
    ]
  },
  {
    name: 'isAcceptVariableFee',
    label: 'Accepts Generic Variable Fee',
    dataType: 'boolean',
    editable: true,
    type: 'threestate',
    suggest: true,
    aryMatches: [
      'Generic Variable Fee', 'Generic Var Fee', 'GenericVariableFee', 'GenericVarFee', 'GenVarFee', 'Gen Var Fee', 'Accepts Generic Variable Fee'
    ]
  },
  {
    name: 'isAcceptAmexVariableFee',
    label: 'Accepts Amex Variable Fee',
    dataType: 'boolean',
    editable: true,
    type: 'threestate',
    suggest: true,
    aryMatches: [
      'Amex Variable Fee', 'Amex Var Fee', 'AmexVariableFee', 'AmexVarFee', 'Accepts Amex Variable Fee', 'Accepts American Express Variable Fee', 'American Express Variable Fee'
    ]
  },
  {
    name: 'isAcceptVisaVariableFee',
    label: 'Accepts Visa Variable Fee',
    dataType: 'boolean',
    editable: true,
    type: 'threestate',
    suggest: true,
    aryMatches: [
      'Visa Variable Fee', 'Visa Var Fee', 'VisaVariableFee', 'VisaVarFee', 'Accepts Visa Variable Fee', 'Visa Variable Fee'
    ]
  },
  {
    name: 'isAcceptMasterCardVariableFee',
    label: 'Accepts MasterCard Variable Fee',
    dataType: 'boolean',
    editable: true,
    type: 'threestate',
    suggest: true,
    aryMatches: [
      'MasterCard Variable Fee', 'MasterCard Var Fee', 'MasterCardVariableFee', 'MasterCardVarFee', 'Accepts MasterCard Variable Fee', 'MasterCard Variable Fee'
    ]
  },
  {
    name: 'notes',
    label: 'Notes',
    dataType: 'string',
    editable: true,
    suggest: true,
    aryMatches: [
      'Note', 'Card Acceptance Note', 'card Note', 'Vendor Note', 'VendorNote'
    ]
  },
  {
    name: 'portalUrl',
    label: 'Portal Url',
    dataType: 'url',
    suggest: true,
    aryMatches: [
      'Portal URL', 'PortalURL', 'PortalUrl'
    ]
  },
  {
    name: 'thirdPartyPortalUrl',
    label: 'Third Party Portal URL',
    dataType: 'url',
    suggest: true,
    aryMatches: [
      '3rd Party Portal URL', 'Third Party Portal URL', '3rdPartyPortalURL', 'ThirdPartyPortalURL'
    ]
  },
  {
    name: 'isAcceptPointOfSalePortal',
    label: 'Accepts Point of Sale',
    dataType: 'boolean',
    suggest: true,
    aryMatches: [
      'Point of Sale', 'Time of Purchase', 'POS'
    ]
  },
  {
    name: 'genericDollarProcessingFee',
    label: 'Generic $ Processing Fee',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Generic Dollar Processing Fee', 'Generic $ Processing Fee', 'Generic Fee Dollar', 'Generic Fee $', '$ Generic Fee', 'Generic $ fee', 'Generic Dollar Fee', 'GenericDollarFee'
    ]
  },
  {
    name: 'genericPercentProcessingFee',
    label: 'Generic % Processing Fee',
    dataType: 'percent',
    editable: true,
    suggest: true,
    aryMatches: [
      'Generic Percent Processing Fee', 'Generic % Processing Fee', 'Generic Fee Percent', 'Generic Fee %', '% Generic Fee', 'Generic % fee', 'Generic Percent Fee', 'GenericPercentFee'
    ]
  },
  {
    name: 'amexProcessingDollarFeeValue',
    label: 'Amex Processing $ Fee',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Amex Processing $ Fee', 'Amex Processing Dollar Fee', 'AmexProcessingDollarFee', 'AmexDollarFee', 'Amex Dollar Fee', 'Amex $ Fee'
    ]
  },
  {
    name: 'amexProcessingPercentFeeValue',
    label: 'Amex Processing % Fee',
    dataType: 'percent',
    editable: true,
    suggest: true,
    aryMatches: [
      'Amex Processing % Fee', 'Amex Processing Percent Fee', 'AmexProcessingPercentFee', 'AmexPercentFee', 'Amex Percent Fee', 'Amex % Fee'
    ]
  },
  {
    name: 'visaProcessingDollarFeeValue',
    label: 'Visa Processing $ Fee',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Visa Processing $ Fee', 'Visa Processing Dollar Fee', 'VisaProcessingDollarFee', 'VisaDollarFee', 'Visa Dollar Fee', 'Visa $ Fee'
    ]
  },
  {
    name: 'visaProcessingPercentFeeValue',
    label: 'Visa Processing % Fee',
    dataType: 'percent',
    editable: true,
    suggest: true,
    aryMatches: [
      'Visa Processing % Fee', 'Visa Processing Percent Fee', 'VisaProcessingPercentFee', 'VisaPercentFee', 'Visa Percent Fee', 'Visa % Fee'
    ]
  },
  {
    name: 'mastercardProcessingDollarFeeValue',
    label: 'MasterCard Processing $ Fee',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'MasterCard Processing $ Fee', 'MasterCard Processing Dollar Fee', 'MasterCardProcessingDollarFee', 'MasterCardDollarFee', 'MasterCard Dollar Fee', 'MasterCard $ Fee'
    ]
  },
  {
    name: 'mastercardProcessingPercentFeeValue',
    label: 'MasterCard Processing % Fee',
    dataType: 'percent',
    editable: true,
    suggest: true,
    aryMatches: [
      'MasterCard Processing % Fee', 'MasterCard Processing Percent Fee', 'MasterCardProcessingPercentFee', 'MasterCardPercentFee', 'MasterCard Percent Fee', 'MasterCard % Fee'
    ]
  },
  {
    name: 'genericDollarMinFee',
    label: 'Generic $ Minimum Fee',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Generic $ Minimum Fee', 'Generic Minimum Fee $', '$ Generic Minimum Fee', 'Generic Minimum $ fee', 'Generic Dollar Minimum Fee', 'GenericDollarMinimumFee', '$ Min Fee', 'Dollar Min Fee'
    ]
  },
  {
    name: 'genericPercentMinFee',
    label: 'Generic % Minimum Fee',
    dataType: 'percent',
    editable: true,
    suggest: true,
    aryMatches: [
      'Generic % Minimum Fee', 'Generic Minimum Fee %', '% Generic Minimum Fee', 'Generic Minimum % fee', 'Generic Percent Minimum Fee', 'GenericPercentMinimumFee', '% Min Fee', 'Percent Min Fee'
    ]
  },
  {
    name: 'amexDollarMinPaymentFeeValue',
    label: 'Amex $ Minimum Fee',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Amex Minimum $ Fee', 'Amex Minimum Dollar Fee', 'AmexMinimumDollarFee', 'Amex $ Minimum Fee', 'Amex $ Min Fee', 'Amex Min $ Fee', '$ Amex Min Fee'
    ]
  },
  {
    name: 'amexPercentMinPaymentFeeValue',
    label: 'Amex % Minimum Fee',
    dataType: 'percent',
    editable: true,
    suggest: true,
    aryMatches: [
      'Amex Minimum % Fee', 'Amex Minimum Percent Fee', 'AmexMinimumPercentFee', 'Amex % Minimum Fee', 'Amex % Min Fee', 'Amex Min % Fee', '% Amex Min Fee'
    ]
  },
  {
    name: 'visaDollarMinPaymentFeeValue',
    label: 'Visa $ Minimum Fee',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Visa Minimum $ Fee', 'Visa Minimum Dollar Fee', 'VisaMinimumDollarFee', 'Visa $ Minimum Fee', 'Visa $ Min Fee', 'Visa Min $ Fee', '$ Visa Min Fee'
    ]
  },
  {
    name: 'visaPercentMinPaymentFeeValue',
    label: 'Visa % Minimum Fee',
    dataType: 'percent',
    editable: true,
    suggest: true,
    aryMatches: [
      'Visa Minimum % Fee', 'Visa Minimum Percent Fee', 'VisaMinimumPercentFee', 'Visa % Minimum Fee', 'Visa % Min Fee', 'Visa Min % Fee', '% Visa Min Fee'
    ]
  },
  {
    name: 'mastercardDollarMinPaymentFeeValue',
    label: 'MasterCard $ Minimum Fee',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'MasterCard Minimum $ Fee', 'MasterCard Minimum Dollar Fee', 'MasterCardMinimumDollarFee', 'MasterCard $ Minimum Fee', 'MasterCard $ Min Fee', 'MasterCard Min $ Fee', '$ MasterCard Min Fee'
    ]
  },
  {
    name: 'mastercardPercentMinPaymentFeeValue',
    label: 'MasterCard % Minimum Fee',
    dataType: 'percent',
    editable: true,
    suggest: true,
    aryMatches: [
      'MasterCard Minimum % Fee', 'MasterCard Minimum Percent Fee', 'MasterCardMinimumPercentFee', 'MasterCard % Minimum Fee', 'MasterCard % Min Fee', 'MasterCard Min % Fee', '% MasterCard Min Fee'
    ]
  },
  {
    name: 'genericDollarMaxFee',
    label: 'Generic $ Maximum Fee',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Generic $ Maximum Fee', 'Generic Maximum Fee $', '$ Generic Maximum Fee', 'Generic Maximum $ fee', 'Generic Dollar Maximum Fee', 'GenericDollarMaximumFee', '$ Max Fee', 'Dollar Max Fee'
    ]
  },
  {
    name: 'genericPercentMaxFee',
    label: 'Generic % Maximum Fee',
    dataType: 'percent',
    editable: true,
    suggest: true,
    aryMatches: [
      'Generic % Maximum Fee', 'Generic Maximum Fee %', '% Generic Maximum Fee', 'Generic Maximum % fee', 'Generic Percent Maximum Fee', 'GenericPercentMaximumFee', '% Max Fee', 'Percent Max Fee'
    ]
  },
  {
    name: 'amexDollarMaxPaymentFeeValue',
    label: 'Amex $ Maximum Fee',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Amex Maximum $ Fee', 'Amex Maximum Dollar Fee', 'AmexMaximumDollarFee', 'Amex $ Maximum Fee', 'Amex $ Max Fee', 'Amex Max $ Fee', '$ Amex Max Fee'
    ]
  },
  {
    name: 'amexPercentMaxPaymentFeeValue',
    label: 'Amex % Maximum Fee',
    dataType: 'percent',
    editable: true,
    suggest: true,
    aryMatches: [
      'Amex Maximum % Fee', 'Amex Maximum Percent Fee', 'AmexMaximumPercentFee', 'Amex % Maximum Fee', 'Amex % Max Fee', 'Amex Max % Fee', '% Amex Max Fee'
    ]
  },
  {
    name: 'visaDollarMaxPaymentFeeValue',
    label: 'Visa $ Maximum Fee',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Visa Maximum $ Fee', 'Visa Maximum Dollar Fee', 'VisaMaximumDollarFee', 'Visa $ Maximum Fee', 'Visa $ Max Fee', 'Visa Max $ Fee', '$ Visa Max Fee'
    ]
  },
  {
    name: 'visaPercentMaxPaymentFeeValue',
    label: 'Visa % Maximum Fee',
    dataType: 'percent',
    editable: true,
    suggest: true,
    aryMatches: [
      'Visa Maximum % Fee', 'Visa Maximum Percent Fee', 'VisaMaximumPercentFee', 'Visa % Maximum Fee', 'Visa % Max Fee', 'Visa Max % Fee', '% Visa Max Fee'
    ]
  },
  {
    name: 'mastercardDollarMaxPaymentFeeValue',
    label: 'MasterCard $ Maximum Fee',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'MasterCard Maximum $ Fee', 'MasterCard Maximum Dollar Fee', 'MasterCardMaximumDollarFee', 'MasterCard $ Maximum Fee', 'MasterCard $ Max Fee', 'MasterCard Max $ Fee', '$ MasterCard Max Fee'
    ]
  },
  {
    name: 'mastercardPercentMaxPaymentFeeValue',
    label: 'MasterCard % Maximum Fee',
    dataType: 'percent',
    editable: true,
    suggest: true,
    aryMatches: [
      'MasterCard Maximum % Fee', 'MasterCard Maximum Percent Fee', 'MasterCardMaximumPercentFee', 'MasterCard % Maximum Fee', 'MasterCard % Max Fee', 'MasterCard Max % Fee', '% MasterCard Max Fee'
    ]
  },
  {
    name: 'genericDollarIncrementalFee',
    label: 'Generic $ Incremental Fee',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Generic $ Incremental Fee', 'Generic Incremental Fee $', '$ Generic Incremental Fee', 'Generic Incremental $ fee', 'Generic Dollar Incremental Fee', 'GenericDollarIncrementalFee', '$ Incremental Fee', 'Dollar Incremental Fee'
    ]
  },
  {
    name: 'genericPercentIncrementalFee',
    label: 'Generic % Incremental Fee',
    dataType: 'percent',
    editable: true,
    suggest: true,
    aryMatches: [
      'Generic % Incremental Fee', 'Generic Incremental Fee %', '% Generic Incremental Fee', 'Generic Incremental % fee', 'Generic Percent Incremental Fee', 'GenericPercentIncrementalFee', '% Incremental Fee', 'Percent Incremental Fee'
    ]
  },
  {
    name: 'amexDollarIncrementalPaymentFeeValue',
    label: 'Amex $ Incremental Fee',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Amex Incremental $ Fee', 'Amex Incremental Dollar Fee', 'AmexIncrementalDollarFee', 'Amex $ Incremental Fee', 'Amex $ Incremental Fee', 'Amex Incremental $ Fee', '$ Amex Incremental Fee'
    ]
  },
  {
    name: 'amexPercentIncrementalPaymentFeeValue',
    label: 'Amex % Incremental Fee',
    dataType: 'percent',
    editable: true,
    suggest: true,
    aryMatches: [
      'Amex Incremental % Fee', 'Amex Incremental Percent Fee', 'AmexIncrementalPercentFee', 'Amex % Incremental Fee', 'Amex % Incremental Fee', 'Amex Incremental % Fee', '% Amex Incremental Fee'
    ]
  },
  {
    name: 'visaDollarIncrementalPaymentFeeValue',
    label: 'Visa $ Incremental Fee',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Visa Incremental $ Fee', 'Visa Incremental Dollar Fee', 'VisaIncrementalDollarFee', 'Visa $ Incremental Fee', 'Visa $ Incremental Fee', 'Visa Incremental $ Fee', '$ Visa Incremental Fee'
    ]
  },
  {
    name: 'visaPercentIncrementalPaymentFeeValue',
    label: 'Visa % Incremental Fee',
    dataType: 'percent',
    editable: true,
    suggest: true,
    aryMatches: [
      'Visa Incremental % Fee', 'Visa Incremental Percent Fee', 'VisaIncrementalPercentFee', 'Visa % Incremental Fee', 'Visa % Incremental Fee', 'Visa Incremental % Fee', '% Visa Incremental Fee'
    ]
  },
  {
    name: 'mastercardDollarIncrementalPaymentFeeValue',
    label: 'MasterCard $ Incremental Fee',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'MasterCard Incremental $ Fee', 'MasterCard Incremental Dollar Fee', 'MasterCardIncrementalDollarFee', 'MasterCard $ Incremental Fee', 'MasterCard $ Incremental Fee', 'MasterCard Incremental $ Fee', '$ MasterCard Incremental Fee'
    ]
  },
  {
    name: 'mastercardPercentIncrementalPaymentFeeValue',
    label: 'MasterCard % Incremental Fee',
    dataType: 'percent',
    editable: true,
    suggest: true,
    aryMatches: [
      'MasterCard Incremental % Fee', 'MasterCard Incremental Percent Fee', 'MasterCardIncrementalPercentFee', 'MasterCard % Incremental Fee', 'MasterCard % Incremental Fee', 'MasterCard Incremental % Fee', '% MasterCard Incremental Fee'
    ]
  },
  {
    name: 'genericMinPayment',
    label: 'Generic Min Payment',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Generic Min payment', 'Generic Minimum payment', 'Minimum Payment', 'Min Payment', 'MinPayment', 'MinimumPayment', 'GenericMinimumPayment', 'GenericMinPayment'
    ]
  },
  {
    name: 'genericMaxPayment',
    label: 'Generic Max Payment',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Generic Max payment', 'Generic Maximum payment', 'Maximum Payment', 'Max Payment', 'MaxPayment', 'MaximumPayment', 'GenericMaximumPayment', 'GenericMaxPayment'
    ]
  },
  {
    name: 'genericIncrementalPayment',
    label: 'Generic Incremental Payment',
    dataType: 'currency',
    editable: true,
    suggest: true,
    aryMatches: [
      'Generic Incremental payment', 'Generic Inc payment', 'Incremental Payment', 'Inc Payment', 'IncPayment', 'IncrementalPayment', 'GenericIncrementalPayment', 'GenericIncPayment'
    ]
  },
  {
    name: 'isAcceptCheckPayments',
    label: 'Accepts Check Payments',
    dataType: 'boolean',
    editable: true,
    type: 'threestate'
  },
  {
    name: 'isAcceptAchPayments',
    label: 'Accepts ACH Payments',
    dataType: 'boolean',
    editable: true,
    type: 'threestate'
  },
  {
    name: 'checkAddress1',
    label: 'Check Address Line 1',
    dataType: 'string',
    editable: true,
    suggest: true,
    aryMatches: [
      'Check Address', 'Check Address1', 'Check Address 1', 'Check Address Line 1', 'Check Street', 'Check AD1', 'Check AD 1',
    ],
  },
  {
    name: 'checkAddress2',
    label: 'Check Address Line 2',
    dataType: 'string',
    editable: true,
    suggest: true,
    aryMatches: [
      'Check Address Line2', 'Check Address2', 'Check Address 2', 'Check Address Line 2', 'Check AD2', 'Check AD 2',
    ]
  },
  {
    name: 'checkCity',
    label: 'Check City',
    dataType: 'string',
    editable: true,
    suggest: true,
    aryMatches: [
      'Check City'
    ]
  },
  {
    name: 'checkState',
    label: 'Check State',
    dataType: 'string',
    editable: true,
    suggest: true,
    aryMatches: [
      'Check State'
    ]
  },
  {
    name: 'checkZip',
    label: 'Check Zip',
    dataType: 'string',
    suggest: true,
    editable: true,
    aryMatches: [
      'Check Zip', 'Check Zip Code', 'Check Postal Code'
    ]
  },
  {
    name: 'checkCountry',
    label: 'Check Country',
    dataType: 'string',
    editable: true,
    suggest: true,
    aryMatches: [
      'Check Country'
    ]
  },
  {
    name: 'partnerSupplierId',
    label: 'Partner Supplier Id',
    dataType: 'string',
    editable: false,
    suggest: true,
    aryMatches: [
      'Partner Supplier Id', 'PartnerSupplierId'
    ],
    dataSource: 'list'
  },
  {
    name: 'accountNumber',
    label: 'Account Number',
    dataType: 'digit',
    editable: false,
    suggest: true,
    aryMatches: [
      'Account Number', 'accountNumber'
    ],
    dataSource: 'list'
  },
  {
    name: 'dbaSupplierName',
    label: 'DBA Supplier Name',
    dataType: 'string',
    editable: true,
    suggest: true,
    aryMatches: [
      'dbaSupplierName', 'DBA Supplier Name', 'dba-Supplier-Name', 'dba_Supplier_Name'
    ]
  },
  {
    name: 'industry',
    label: 'Industry',
    dataType: 'string',
    editable: true,
    suggest: true,
    aryMatches: [
      'industry', 'Industry'
    ]
  },
  {
    name: 'linkedinUrl',
    label: 'Linkedin Url',
    dataType: 'url',
    editable: true,
    suggest: true,
    aryMatches: [
      'linkedinUrl', 'linkedin-Url', 'Linkedin Url, linkedin_url'
    ]
  },
  {
    name: 'parentOrganization',
    label: 'Parent Organization',
    dataType: 'string',
    editable: true,
    suggest: true,
    aryMatches: [
      'parentOrganization', 'parent-Organization', 'Parent Organization', 'parent_Organization'
    ]
  },
  {
    name: 'lastInvoiceNumber',
    label: 'Last Invoice Number',
    dataType: 'string',
    editable: true,
    suggest: true,
    aryMatches: [
      'lastInvoiceNumber', 'last-Invoice-Number', 'Last Invoice Number', 'last_Invoice-Number'
    ]
  },
  {
    name: 'paymentCount',
    label: 'Payment Count',
    dataType: 'integer',
    editable: true,
    suggest: true,
    aryMatches: [
      'paymentCount', 'Payment Count', 'payment-Count', 'payment_Count'
    ]
  }
]

export const defaultUploadSupplierColumns = [
  {
    name: 'masterId',
    label: 'Master Id',
  },
  {
    name: 'suppliername',
    label: 'Supplier Name',
  },
  {
    name: 'address1',
    label: 'Address Line 1',
  },
  {
    name: 'address2',
    label: 'Address Line 2'
  },
  {
    name: 'city',
    label: 'City',
  },
  {
    name: 'state',
    label: 'State',
  },
  {
    name: 'zip',
    label: 'Zip',
  },
  {
    name: 'country',
    label: 'Country'
  },
  {
    name: 'phone',
    label: 'Phone No'
  },
  {
    name: 'fax',
    label: 'Fax'
  },
  {
    name: 'email',
    label: 'Email'
  },
  {
    name: 'url',
    label: 'Url'
  },
  {
    name: 'taxId',
    label: 'Tax Id',
  },
  {
    name: 'naics',
    label: 'NAICS',
  },
  {
    name: 'sic',
    label: 'SIC Code',
  },
]

export const defaultUploadSupplierDetailColumns = [
  {
    name: 'spend',
    label: 'Spend'
  },
  {
    name: 'spendTimeFrame',
    label: 'Spend Time Frame'
  },
  {
    name: 'spendTimeType',
    label: 'Spend Time Type'
  },
  {
    name: 'annualizedSpend',
    label: 'Annual Vendor Spend'
  },
  {
    name: 'contactDate',
    label: 'Contacted Date'
  },
  {
    name: 'contactNameOld',
    label: 'Contact Name'
  },
]

// default all supplier columns, card columns, payment columns and merchant columns
export const defaultAllSupplierColumns = [
  {
    name: 'domainId',
    label: 'Domain Id',
  },
  {
    name: 'listId',
    label: 'List Id',
  },
  {
    name: 'companyId',
    label: 'Company Id',
  },
  {
    name: 'erpVendorId',
    label: 'ERP Vendor Id',
  },
  {
    name: 'suppliername',
    label: 'Supplier Name',
  },
  {
    name: 'address1',
    label: 'Address Line 1',
  },
  {
    name: 'address2',
    label: 'Address Line 2'
  },
  {
    name: 'city',
    label: 'City',
  },
  {
    name: 'state',
    label: 'State',
  },
  {
    name: 'region',
    label: 'Region',
  },
  {
    name: 'zip',
    label: 'Zip',
  },
  {
    name: 'country',
    label: 'Country'
  },
  {
    name: 'phone',
    label: 'Phone No'
  },
  {
    name: 'fax',
    label: 'Fax'
  },
  {
    name: 'email',
    label: 'Email'
  },
  {
    name: 'paymentPortal',
    label: 'Payment Portal',
  },
  {
    name: 'credentialRequired',
    label: 'Credential Required',
  },
  {
    name: 'approvedByManager',
    label: 'Approved By Manager',
  },
  {
    name: 'masterId',
    label: 'Master Id',
  },
  {
    name: 'isMaster',
    label: 'Is Master',
  },
  {
    name: 'userId',
    label: 'User Id',
  },
  {
    name: 'url',
    label: 'Url'
  },
  {
    name: 'taxId',
    label: 'Tax Id',
  },
  {
    name: 'naics',
    label: 'NAICS',
  },
  {
    name: 'sic',
    label: 'SIC Code',
  },
  {
    name: 'autoCreateMaster',
    label: 'Auto Create Master',
  },
  {
    name: 'fullAddress',
    label: 'Full Address',
  },
  {
    name: 'employerIdNumber',
    label: 'Employer Id Number'
  },
  {
    name: 'partnerSupplierId',
    label: 'Partner Supplier Id'
  },
  {
    name: 'accountNumber',
    label: 'Account Number'
  },
  {
    name: 'dbaSupplierName',
    label: 'DBA Supplier Name'
  },
  {
    name: 'industry',
    label: 'Industry'
  },
  {
    name: 'linkedinUrl',
    label: 'LinkedIn URL'
  },
  {
    name: 'parentOrganization',
    label: 'Parent Organization'
  }
]

export const defaultAllCardColumns = [
  {
    name: 'currentPaymentMethod',
    label: 'Current Payment Method'
  },
  {
    name: 'isAcceptAmericanExpress',
    label: 'Accepts American Express'
  },
  {
    name: 'isAcceptMasterCard',
    label: 'Accepts Mastercard'
  },
  {
    name: 'isAcceptVisa',
    label: 'Accepts Visa'
  },
  {
    name: 'isAcceptDiscover',
    label: 'Accepts Discover'
  },
  {
    name: 'hasAcceptanceConditionForAmericanExpress',
    label: 'Has Acceptance Conditions for American Express'
  },
  {
    name: 'hasAcceptanceConditionForMastercard',
    label: 'Has Acceptance Conditions for Mastercard'
  },
  {
    name: 'hasAcceptanceConditionForVisa',
    label: 'Has Acceptance Conditions for Visa'
  },
  {
    name: 'hasAcceptanceConditionForDiscover',
    label: 'Has Acceptance Conditions for Discover'
  },
  {
    name: 'isAcceptCardPaymentByEmail',
    label: 'Accepts Card Payment by Email'
  },
  {
    name: 'isAcceptCardPaymentByFax',
    label: 'Accepts Card Payment by Fax'
  },
  {
    name: 'isAcceptCardPaymentByPhone',
    label: 'Accepts Card Payment by Phone'
  },
  {
    name: 'isAcceptCardPaymentByOnlinePortal',
    label: 'Accepts Card Payment by Online Portal'
  },
  {
    name: 'americanExpressMinPaymnet',
    label: 'American Express Min Payment'
  },
  {
    name: 'americanExpressMaxPayment',
    label: 'American Express Max Payment'
  },
  {
    name: 'mastercardMinPayment',
    label: 'Mastercard Min Payment'
  },
  {
    name: 'mastercardMaxPayment',
    label: 'Mastercard Max Payment'
  },
  {
    name: 'visaMinPayment',
    label: 'Visa Min Payment'
  },
  {
    name: 'visaMaxPayment',
    label: 'Visa Max Payment'
  },
  {
    name: 'DiscoverPercentFee',
    label: 'Discover % Fee'
  },
  {
    name: 'discoverDollarFee',
    label: 'Discover $ Fee'
  },
  {
    name: 'discoverMinPayment',
    label: 'Discover Min Payment'
  },
  {
    name: 'discoerMaxPayment',
    label: 'Discover Max Payment'
  },
  {
    name: 'ccProcessingTime',
    label: 'CC Processing Time'
  },
  {
    name: 'isCredentialsRequired',
    label: 'IS Credentials Required',
  },
  {
    name: 'tokenType',
    label: 'Token type',
  },
  {
    name: 'cardPaymentByPhoneValue',
    label: 'Card Acceptance Phone',
  },
  {
    name: 'cardPaymentByFaxValue',
    label: 'Card Acceptance Email',
  },
  {
    name: 'isAcceptAmexVariableFee',
    label: 'Accepts Amex Variable Fee'
  },
  {
    name: 'isAcceptVisaVariableFee',
    label: 'Accepts Visa variable Fee'
  },
  {
    name: 'isAcceptMasterCardVariableFee',
    label: 'Accepts MasterCard Variable Fee'
  },
  {
    name: 'isAcceptVariableFee',
    label: 'Accepts Generic Variable Fee'
  },
  {
    name: 'portalUrl',
    label: 'Portal URL'
  },
  {
    name: 'thirdPartyPortalUrl',
    label: 'Third Party Portal URL'
  },
  {
    name: 'amexProcessingFeeValue',
    label: 'Amex Processing Fee'
  },
  {
    name: 'visaProcessingFeeValue',
    label: 'Visa Processing Fee'
  },
  {
    name: 'mastercardProcessingFeeValue',
    label: 'Mastercard Processing Fee'
  },
  {
    name: 'isAcceptPointOfSalePortal',
    label: 'Accepts Point of Sale'
  },
  {
    name: 'amexMinPaymentFeeValue',
    label: 'Amex Minimun Fee'
  },
  {
    name: 'amexMaxPaymentFeeValue',
    label: 'Amex Maximum Fee'
  },
  {
    name: 'amexIncrementalFeeValue',
    label: 'Amex Incremental Fee'
  },
  {
    name: 'visaMinPaymentFeeValue',
    label: 'Visa Minimun Fee'
  },
  {
    name: 'visaMaxPaymentFeeValue',
    label: 'Visa Maximum Fee'
  },
  {
    name: 'visaIncrementalFeeValue',
    label: 'Visa Incremental Fee'
  },
  {
    name: 'mastercardMinPaymentFeeValue',
    label: 'Mastercard Minimun Fee'
  },
  {
    name: 'mastercardMaxPaymentFeeValue',
    label: 'Mastercard Maximum Fee'
  },
  {
    name: 'mastercardIncrementalFeeValue',
    label: 'Mastercard Incremental Fee'
  },
  {
    name: 'amexIncrementalPaymentAmount',
    label: 'Amex Incremental Payment'
  },
  {
    name: 'visaIncrementalPaymentAmount',
    label: 'Visa Incremental Payment'
  },
  {
    name: 'mastercardIncrementalPaymentAmount',
    label: 'Mastercard Incremental Payment'
  }
]

export const defaultAllPaymentColumns = [
  {
    name: 'isAcceptCheckPayments',
    label: 'Accept check payments',
  },
  {
    name: 'isAcceptAchPayments',
    label: 'Accept ach payments',
  },
  {
    name: 'achInstructions',
    label: 'Ach Instructions',
  },
  {
    name: 'bankAccountNumber',
    label: 'Bank Account Number',
  },
  {
    name: 'bankRoutingNumber',
    label: 'Bank Routing Number',
  },
  {
    name: 'isCheckPayper',
    label: 'Check Payper',
  },
  {
    name: 'isCheckDigital',
    label: 'Check Digital',
  },
  {
    name: 'isCheckMailToName',
    label: 'Check mail to name',
  },
  {
    name: 'checkAddress1',
    label: 'Check Address 1',
  },
  {
    name: 'checkAddress2',
    label: 'Check Address 2',
  },
  {
    name: 'checkCity',
    label: 'Check City',
  },
  {
    name: 'checkState',
    label: 'Check State',
  },
  {
    name: 'checkZip',
    label: 'Check Zip',
  },
  {
    name: 'checkCountry',
    label: 'Check Country',
  },
  {
    name: 'emailCreditCard',
    label: 'Email Credit Card',
  },
  {
    name: 'emailAch',
    label: 'Email Ach',
  },
  {
    name: 'phone',
    label: 'Phone',
  },
  {
    name: 'fax',
    label: 'Fax',
  },
  {
    name: 'currentPaymentMethod',
    label: 'Current Payment Method',
  },
  {
    name: 'paymentPortal',
    label: 'Payment Portal',
  },
]

export const defaultAllMerchantColumns = [
  {
    name: 'tokenType',
    label: 'Token Type',
  },
  {
    name: 'merchantNumber',
    label: 'Merchant Number',
  },
  {
    name: 'merchantCategoryCode',
    label: 'Merchant Category Code',
  },
  {
    name: 'merchantName',
    label: 'Merchant Name',
  },
  {
    name: 'merchantCity',
    label: 'Merchant City',
  },
  {
    name: 'merchantState',
    label: 'Merchant State',
  },
  {
    name: 'merchantZip',
    label: 'Merchant Zip',
  },
  {
    name: 'merchantCountry',
    label: 'Merchant Country',
  },
]

// columns for table Master Supplier Record and Child Supplier Lookup
export const defaultMasterVendorColumns = [
  {
    name: 'suppliername',
    label: 'Master Supplier Name'
  },
  {
    name: 'address1',
    label: 'Address 1'
  },
  {
    name: 'address2',
    label: 'Address 2'
  },
  {
    name: 'city',
    label: 'City'
  },
  {
    name: 'state',
    label: 'State'
  },
  {
    name: 'zip',
    label: 'Zip'
  },
  {
    name: 'country',
    label: 'Country'
  },
  {
    name: 'phone',
    label: 'Phone No'
  },
  {
    name: 'email',
    label: 'Email',
  },
  {
    name: 'spend',
    label: 'Spend'
  },
  {
    name: 'contactedDate',
    label: 'Contacted Date'
  },
  {
    name: 'contactName',
    label: 'Contact Name'
  },
  {
    name: 'isOnlyAcceptCardAsPos',
    label: 'Only Accepts Card as POS'
  },
  {
    name: 'isAcceptAmericanExpress',
    label: 'Accepts American Express'
  },
  {
    name: 'isAcceptMasterCard',
    label: 'Accepts Mastercard'
  },
  {
    name: 'isAcceptVisa',
    label: 'Accepts Visa'
  },
  {
    name: 'hasAcceptanceConditionForAmericanExpress',
    label: 'Has Acceptance Conditions for American Express'
  },
  {
    name: 'hasAcceptanceConditionForMastercard',
    label: 'Has Acceptance Conditions for Mastercard'
  },
  {
    name: 'hasAcceptanceConditionForVisa',
    label: 'Has Acceptance Conditions for Visa'
  },
  {
    name: 'isAcceptCardPaymentByEmail',
    label: 'Accepts Card Payment by Email'
  },
  {
    name: 'isAcceptCardPaymentByFax',
    label: 'Accepts Card Payment by Fax'
  },
  {
    name: 'isAcceptCardPaymentByPhone',
    label: 'Accepts Card Payment by Phone'
  },
  {
    name: 'isAcceptCardPaymentByOnlinePortal',
    label: 'Accepts Card Payment by Online Portal'
  },
  {
    name: 'americanExpressPercentFee',
    label: 'American Express % Fee'
  },
  {
    name: 'americanExpressDollarFee',
    label: 'American Express $ Fee'
  },
  {
    name: 'americanExpressMinPaymnet',
    label: 'American Express Min Payment'
  },
  {
    name: 'americanExpressMaxPayment',
    label: 'American Express Max Payment'
  },
  {
    name: 'mastercardPercentFee',
    label: 'Mastercard % Fee'
  },
  {
    name: 'mastercardDollarFee',
    label: 'Mastercard $ Fee'
  },
  {
    name: 'mastercardMinPayment',
    label: 'Mastercard Min Payment'
  },
  {
    name: 'mastercardMaxPayment',
    label: 'Mastercard Max Payment'
  },
  {
    name: 'visaPercentFee',
    label: 'Visa % Fee'
  },
  {
    name: 'visaDollarFee',
    label: 'Visa $ Fee'
  },
  {
    name: 'visaMinPayment',
    label: 'Visa Min Payment'
  },
  {
    name: 'visaMaxPayment',
    label: 'Visa Max Payment'
  },
  {
    name: 'erpVendorId',
    label: 'ERP Vendor ID'
  },
  {
    name: 'currentPaymentMethod',
    label: 'Current Payment Method'
  },
  {
    name: 'bankAccountNumber',
    label: 'Bank Account Number'
  },
  {
    name: 'bankRoutingNumber',
    label: 'Bank Routing Number'
  },
  {
    name: 'cardAcceptanceNotes',
    label: 'Card Acceptance Notes'
  },
]

export const defaultChildSupplierColumns = [
  {
    name: 'suppliername',
    label: 'Supplier Name',
    required: true,
    dataType: 'string',
  },
  {
    name: 'masterSupplierName',
    label: 'Master Supplier Name',
  },
  {
    name: 'address1',
    label: 'Address Line 1',
    required: true,
    dataType: 'string',
  },
  {
    name: 'address2',
    label: 'Address Line 2'
  },
  {
    name: 'city',
    label: 'City',
    required: true,
    dataType: 'string',
  },
  {
    name: 'state',
    label: 'State',
    required: true,
    dataType: 'string',
  },
  {
    name: 'zip',
    label: 'Zip',
    required: true,
    dataType: 'string',
  },
  {
    name: 'country',
    label: 'Country'
  },
  {
    name: 'phone',
    label: 'Phone No'
  },
  {
    name: 'fax',
    label: 'Fax'
  },
  {
    name: 'email',
    label: 'Email'
  },
  {
    name: 'url',
    label: 'Url'
  },
  {
    name: 'employerIdNumber',
    label: 'Employer Id Number'
  },
  {
    name: 'contactDate',
    label: 'Contacted Date'
  },
  {
    name: 'contactNameOld',
    label: 'Contact Name'
  }
]

export const defaultMasterSupplierColumns = [
  {
    name: 'suppliername',
    label: 'Master Supplier Name'
  },
  {
    name: 'address1',
    label: 'Address 1'
  },
  {
    name: 'dbaSupplierName',
    label: 'Supplier Name - DBA'
  },
  {
    name: 'address2',
    label: 'Address 2'
  },
  {
    name: 'city',
    label: 'City'
  },
  {
    name: 'abbreviatedState',
    label: 'State'
  },
  {
    name: 'phone',
    label: 'Phone No'
  },
  {
    name: 'zip',
    label: 'Zip'
  },
  {
    name: 'email',
    label: 'Email'
  },
  {
    name: 'country',
    label: 'Country'
  },
  {
    name: 'linkedinUrl',
    label: 'Linkedin Url'
  },
  {
    name: 'sic',
    label: 'SIC Code'
  },
  {
    name: 'industry',
    label: 'Industry'
  },
  {
    name: 'naics',
    label: 'NAICS Code'
  },
  {
    name: 'url',
    label: 'URL'
  },
  {
    name: 'employerIdNumber',
    label: 'Employer Id Number'
  }
]

// Accepts Check, Accepts ACH, Accepts Visa, Accepts Amex, Accepts Mastercard
export const defaultMasterSupplierColumnsRight = [
  {
    name: 'isAcceptCheckPayments',
    label: 'Accepts Check'
  },
  {
    name: 'isAcceptAchPayments',
    label: 'Accepts ACH'
  },
  {
    name: 'isAcceptVisa',
    label: 'Accepts Visa'
  },
  {
    name: 'isAcceptAmericanExpress',
    label: 'Accepts Amex'
  },
  {
    name: 'isAcceptMasterCard',
    label: 'Accepts Mastercard'
  },
]

export const defaultDataSources = [
  {
    name: 'customer',
    label: 'Customer',
    columns: ['masterId', 'companyId', 'erpVendorId', 'suppliername', 'address1', 'address2', 'city', 'state', 'zip', 'country', 'phone', 'fax', 'email', 'url', 'spend', 'annualizedSpend', 'contactDate', 'contactNameOld', 'isOnlyAcceptsCardAsPos', 'isAcceptAmericanExpress', 'isAcceptVisa', 'isAcceptMasterCard', 'isAcceptCardPaymentByEmail', 'isAcceptCardPaymentByFax', 'isAcceptCardPaymentByPhone', 'isAcceptCardPaymentByOnlinePortal', 'americanExpressMinPaymnet', 'americanExpressMaxPayment', 'mastercardMinPayment', 'mastercardMaxPayment', 'visaMinPayment', 'visaMaxPayment', 'currentPaymentMethod', 'bankAccountNumber', 'bankRoutingNumber', 'cardAcceptanceNotes', 'tokenType', 'taxId', 'sic', 'naics', 'autoCreateMaster', 'cardPaymentByPhoneValue', 'cardPaymentByFaxValue', 'cardEmail', 'fullAddress', 'employerIdNumber', 'isAcceptVariableFee', 'isAcceptAmexVariableFee', 'isAcceptVisaVariableFee', 'isAcceptMasterCardVariableFee', 'notes', 'portalUrl', 'thirdPartyPortalUrl', 'isAcceptPointOfSalePortal', 'genericDollarProcessingFee', 'genericPercentProcessingFee', 'amexProcessingDollarFeeValue', 'amexProcessingPercentFeeValue', 'visaProcessingDollarFeeValue', 'visaProcessingPercentFeeValue', 'mastercardProcessingDollarFeeValue', 'mastercardProcessingPercentFeeValue', 'genericDollarMinFee', 'genericPercentMinFee', 'amexDollarMinPaymentFeeValue', 'amexPercentMinPaymentFeeValue', 'visaDollarMinPaymentFeeValue', 'visaPercentMinPaymentFeeValue', 'mastercardDollarMinPaymentFeeValue', 'mastercardPercentMinPaymentFeeValue', 'genericDollarMaxFee', 'genericPercentMaxFee', 'amexDollarMaxPaymentFeeValue', 'amexPercentMaxPaymentFeeValue', 'visaDollarMaxPaymentFeeValue', 'visaPercentMaxPaymentFeeValue', 'mastercardDollarMaxPaymentFeeValue', 'mastercardPercentMaxPaymentFeeValue', 'genericDollarIncrementalFee', 'genericPercentIncrementalFee', 'amexDollarIncrementalPaymentFeeValue', 'amexPercentIncrementalPaymentFeeValue', 'visaDollarIncrementalPaymentFeeValue', 'visaPercentIncrementalPaymentFeeValue', 'mastercardDollarIncrementalPaymentFeeValue', 'mastercardPercentIncrementalPaymentFeeValue', 'genericMinPayment', 'genericMaxPayment', 'genericIncrementalPayment', 'amexIncrementalPaymentAmount', 'visaIncrementalPaymentAmount', 'mastercardIncrementalPaymentAmount', 'isAcceptCheckPayments', 'isAcceptAchPayments', 'checkAddress1', 'checkAddress2', 'checkCity', 'checkState', 'checkZip', 'checkCountry', 'dbaSupplierName', 'industry', 'linkedinUrl', 'parentOrganization', 'lastInvoiceNumber', 'currentPaymentMethod', 'paymentCount']
  },
  {
    name: 'list',
    label: 'List',
    columns: ['masterId', 'erpVendorId', 'suppliername', 'address1', 'address2', 'city', 'state', 'zip', 'country', 'phone', 'fax', 'email', 'url', 'spend', 'annualizedSpend', 'contactDate', 'contactNameOld', 'isOnlyAcceptsCardAsPos', 'isAcceptAmericanExpress', 'isAcceptVisa', 'isAcceptMasterCard', 'isAcceptCardPaymentByEmail', 'isAcceptCardPaymentByFax', 'isAcceptCardPaymentByPhone', 'isAcceptCardPaymentByOnlinePortal', 'americanExpressMinPaymnet', 'americanExpressMaxPayment', 'mastercardMinPayment', 'mastercardMaxPayment', 'visaMinPayment', 'visaMaxPayment', 'currentPaymentMethod', 'bankAccountNumber', 'bankRoutingNumber', 'cardAcceptanceNotes', 'tokenType', 'cardPaymentByPhoneValue', 'cardPaymentByFaxValue', 'fullAddress', 'isAcceptVariableFee', 'isAcceptAmexVariableFee', 'isAcceptVisaVariableFee', 'isAcceptMasterCardVariableFee', 'companyId', 'notes', 'portalUrl', 'thirdPartyPortalUrl', 'isAcceptPointOfSalePortal', 'genericDollarProcessingFee', 'genericPercentProcessingFee', 'amexProcessingDollarFeeValue', 'amexProcessingPercentFeeValue', 'visaProcessingDollarFeeValue', 'visaProcessingPercentFeeValue', 'mastercardProcessingDollarFeeValue', 'mastercardProcessingPercentFeeValue', 'genericDollarMinFee', 'genericPercentMinFee', 'amexDollarMinPaymentFeeValue', 'amexPercentMinPaymentFeeValue', 'visaDollarMinPaymentFeeValue', 'visaPercentMinPaymentFeeValue', 'mastercardDollarMinPaymentFeeValue', 'mastercardPercentMinPaymentFeeValue', 'genericDollarMaxFee', 'genericPercentMaxFee', 'amexDollarMaxPaymentFeeValue', 'amexPercentMaxPaymentFeeValue', 'visaDollarMaxPaymentFeeValue', 'visaPercentMaxPaymentFeeValue', 'mastercardDollarMaxPaymentFeeValue', 'mastercardPercentMaxPaymentFeeValue', 'genericDollarIncrementalFee', 'genericPercentIncrementalFee', 'amexDollarIncrementalPaymentFeeValue', 'amexPercentIncrementalPaymentFeeValue', 'visaDollarIncrementalPaymentFeeValue', 'visaPercentIncrementalPaymentFeeValue', 'mastercardDollarIncrementalPaymentFeeValue', 'mastercardPercentIncrementalPaymentFeeValue', 'genericMinPayment', 'genericMaxPayment', 'genericIncrementalPayment', 'amexIncrementalPaymentAmount', 'visaIncrementalPaymentAmount', 'mastercardIncrementalPaymentAmount', 'isAcceptCheckPayments', 'isAcceptAchPayments', 'checkAddress1', 'checkAddress2', 'checkCity', 'checkState', 'checkZip', 'checkCountry', 'sic', 'naics', 'employerIdNumber', 'cardEmail', 'partnerSupplierId', 'accountNumber', 'dbaSupplierName', 'industry', 'linkedinUrl', 'parentOrganization', 'lastInvoiceNumber', 'currentPaymentMethod', 'paymentCount']
  }
]

export const defaultSideMenus = [
  {
    name: 'dashboard',
    label: 'Dashboard',
    to: '/dashboard',
  },
  {
    name: 'upload',
    label: 'Add Vendor List',
    to: '/upload',
  },
  {
    name: 'lists',
    label: 'My Lists',
    to: '/lists',
  },
  {
    name: 'suppliers/',
    label: 'Suppliers',
    to: '/suppliers/',
  },
  {
    name: 'schedule',
    label: 'Scheudle',
    to: '/schedule',
  },
  {
    name: 'reports',
    label: 'Reports',
    to: '/reports',
  },
  {
    name: 'setting',
    label: 'Settings',
    to: '/setting',
  },
  {
    name: 'domain',
    label: 'Domains',
    to: '/domain',
  },
  {
    name: 'qa/guid',
    label: 'Quality Assurance',
    to: '/qa/guid',
  },
  {
    name: 'user-manage',
    label: 'User Management',
    to: '/user-manage',
  },
  {
    name: 'test',
    label: 'Test',
    to: '/test',
  },
  {
    name: 'partner-manage',
    label: 'Partner Management',
    to: '/partner-manage',
  },
  {
    name: 'caller-settings',
    label: 'Caller Settings',
    to: '/caller-settings',
  }
]

export const defaultRelatedSupplierColumns = [
  {
    name: 'suppliername',
    label: 'Supplier Name'
  },
  {
    name: 'address1',
    label: 'Address 1'
  },
  {
    name: 'address2',
    label: 'Address 2'
  },
  {
    name: 'city',
    label: 'City'
  },
  {
    name: 'abbreviatedState',
    label: 'State'
  },
  {
    name: 'zip',
    label: 'Zip'
  },
  {
    name: 'country',
    label: 'Country'
  },
  {
    name: 'phone',
    label: 'Phone No'
  },
  {
    name: 'email',
    label: 'Email'
  },
  {
    name: 'naics',
    label: 'NAICS Code'
  },
  {
    name: 'url',
    label: 'URL'
  },
  {
    name: 'employerIdNumber',
    label: 'Employer Id Number'
  },
  {
    name: 'sic',
    label: 'SIC Code'
  }
]

export const defaultMasterSupplierTableColumns = [
  {
    name: 'suppliername',
    label: 'Master Supplier Name'
  },
  {
    name: 'relatedSuppliersCount',
    label: '# of Related Suppliers'
  },
  {
    name: 'isAcceptGlobalAcceptance',
    label: 'Global Acceptor'
  },
  {
    name: 'address1',
    label: 'Address 1'
  },
  {
    name: 'address2',
    label: 'Address 2'
  },
  {
    name: 'city',
    label: 'City'
  },
  {
    name: 'state',
    label: 'State'
  },
  {
    name: 'zip',
    label: 'Zip'
  },
  {
    name: 'phone',
    label: 'Phone No'
  },
  {
    name: 'url',
    label: 'URL'
  },
  {
    name: 'employerIdNumber',
    label: 'Employer Id Number'
  }
]

export const notParsedAddressColumns = [
  {
    name: 'Full address that can not be parsed',
    label: 'Full address that can not be parsed'
  },
  {
    name: 'address1',
    label: 'Address1'
  },
  {
    name: 'address2',
    label: 'Address1'
  },
  {
    name: 'city',
    label: 'City'
  },
  {
    name: 'state',
    label: 'State'
  },
  {
    name: 'zip',
    label: 'Zip'
  },
  {
    name: 'country',
    label: 'Country'
  }
]

// create new supplier Columns and Tabs
export const createSupplierTabs = [
  {
    name: 'basic',
    label: 'General Information',
  },
  {
    name: 'card',
    label: 'Card Acceptance',
  },
  {
    name: 'ach',
    label: 'ACH Acceptance',
  },
  {
    name: 'check',
    label: 'Check Acceptance',
  },
]

export const createSupplierBasicColumns = [
  {
    name: 'suppliername',
    label: 'Name',
    fullwidth: true,
  },
  {
    name: 'dbaSupplierName',
    label: 'DBA Supplier Name'
  },
  {
    name: 'address1',
    label: 'Address Line 1',
    fullwidth: true,
  },
  {
    name: 'address2',
    label: 'Address Line 2',
    fullwidth: true,
  },
  {
    name: 'city',
    label: 'City'
  },
  {
    name: 'abbreviatedState',
    label: 'State'
  },
  {
    name: 'state',
    label: 'State'
  },
  {
    name: 'zip',
    label: 'Zip'
  },
  {
    name: 'country',
    label: 'Country'
  },
  {
    name: 'phone',
    label: 'Phone'
  },
  {
    name: 'email',
    label: 'Email'
  },
  {
    name: 'fax',
    label: 'Fax'
  },
  {
    name: 'url',
    label: 'URL'
  },
  {
    name: 'employerIdNumber',
    label: 'Employer Id Number'
  },
  {
    name: 'naics',
    label: 'NAICS'
  },
  {
    name: 'sic',
    label: 'SIC'
  },
  {
    name: 'industry',
    label: 'Industry'
  },
  {
    name: 'linkedinUrl',
    label: 'Linkedin Url'
  }
]

export const createSupplierCardColumns = [
  {
    name: 'isAcceptAmericanExpress',
    label: 'Accepts Amex',
    defaultValue: null,
  },
  {
    name: 'isAcceptVisa',
    label: 'Accepts Visa',
    defaultValue: null,
  },
  {
    name: 'isAcceptMasterCard',
    label: 'Accepts Mastercard',
    defaultValue: null,
  },
  {
    name: 'isAcceptDiscover',
    label: 'Accepts Discover',
    defaultValue: null,
  },
  {
    name: 'acceptCardPaymentType',
    label: 'How Do They Receive Payment',
    defaultValue: 'portal',
  },
  {
    name: 'ccProcessingTime',
    label: 'Standard Processing Time For Credit Card Payments',
    defaultValue: 5,
  },
  {
    name: 'isCredentialsRequired',
    label: 'Are Credentials Required For Payments',
    defaultValue: null,
  },
  {
    name: 'hasAcceptanceConditionForAmericanExpress',
    label: 'Amex Processing Fees',
    defaultValue: false,
  },
  {
    name: 'americanExpressMinPaymnet',
    label: 'Amex Minimum Payment',
    defaultValue: '',
  },
  {
    name: 'americanExpressMaxPayment',
    label: 'Amex Maximum Payment',
    defaultValue: '',
  },
  {
    name: 'americanExpressDollarFee',
    label: 'Amex Dollar Fee',
    defaultValue: '',
  },
  {
    name: 'americanExpressPercentFee',
    label: 'Amex Percent Fee',
    defaultValue: '',
  },
  {
    name: 'hasAcceptanceConditionForVisa',
    label: 'Visa Processing Fees',
    defaultValue: false,
  },
  {
    name: 'visaMinPayment',
    label: 'Visa Minimum Payment',
    defaultValue: '',
  },
  {
    name: 'visaMaxPayment',
    label: 'Visa Maximum Payment',
    defaultValue: '',
  },
  {
    name: 'visaDollarFee',
    label: 'Visa Dollar Fee',
    defaultValue: '',
  },
  {
    name: 'visaPercentFee',
    label: 'Visa Percent Fee',
    defaultValue: '',
  },
  {
    name: 'hasAcceptanceConditionForMastercard',
    label: 'Mastercard Processing Fees',
    defaultValue: false,
  },
  {
    name: 'mastercardMinPayment',
    label: 'Mastercard Minimum Payment',
    defaultValue: '',
  },
  {
    name: 'mastercardMaxPayment',
    label: 'Mastercard Maximum Payment',
    defaultValue: '',
  },
  {
    name: 'mastercardDollarFee',
    label: 'Mastercard Dollar Fee',
    defaultValue: '',
  },
  {
    name: 'mastercardPercentFee',
    label: 'Mastercard Percent Fee',
    defaultValue: '',
  },
  {
    name: 'hasAcceptanceConditionForDiscover',
    label: 'Discover Processing Fees',
    defaultValue: false,
  },
  {
    name: 'discoverMinPayment',
    label: 'Discover Card Minimum Payment',
    defaultValue: '',
  },
  {
    name: 'discoverMaxPayment',
    label: 'Discover Card Maximum Payment',
    defaultValue: '',
  },
  {
    name: 'discoverDollarFee',
    label: 'Discover Card Dollar Fee',
    defaultValue: '',
  },
  {
    name: 'discoverPercentFee',
    label: 'Discover Card Percent Fee',
    defaultValue: '',
  },
  {
    name: 'tokenType',
    label: 'Token Configuration',
    defaultValue: 'single-use-max-amount',
  },
  {
    name: 'isAcceptCardAuthorizationForm',
    label: 'Card Authorization Form',
    defaultValue: false,
  },
  {
    name: 'isAcceptCardPaymentByEmail',
    label: 'Accepts Card Payment By Email',
    defaultValue: false,
  },
  {
    name: 'isAcceptCardPaymentByPhone',
    label: 'Accepts Card Payment By Phone',
    defaultValue: false,
  },
  {
    name: 'isAcceptCardPaymentByFax',
    label: 'Accepts Card Payment By Fax',
    defaultValue: false,
  },
  {
    name: 'isAcceptCardPaymentByOnlinePortal',
    label: 'Accepts Card Payment By Online Portal',
    defaultValue: false,
  },
  {
    name: 'cardPaymentByPhoneValue',
    label: 'Card Payment By Phone Value',
    defaultValue: '',
  },
  {
    name: 'cardPaymentByFaxValue',
    label: 'Card Payment By Fax Value',
    defaultValue: '',
  },
  {
    name: 'isAcceptEcommercePortal',
    label: 'E-Commerce Portal',
    defaultValue: false,
  },
  {
    name: 'isAcceptPortal',
    label: 'Accepts Portal',
    defaultValue: false,
  },
  {
    name: 'isAccept3rdPartyPortal',
    label: 'Accepts 3rd Party Portal',
    defaultValue: false,
  },
  {
    name: 'isAcceptInAppPortal',
    label: 'Accepts In App Portal',
    defaultValue: false,
  },
  {
    name: 'portalUrl',
    label: 'Portal URL',
    defaultValue: '',
  },
  {
    name: 'thirdPartyPortalUrl',
    label: '3rd Party Portal URL',
    defaultValue: '',
  },
  {
    name: 'isAcceptPointOfSalePortal',
    label: 'Accepts Point Of Sale Portal',
    defaultValue: false,
  },
  {
    name: 'isAcceptCardPaymentTerms',
    label: 'Card Payment Terms',
    defaultValue: null,
  },
  {
    name: 'cardPaymentTermsvalue',
    label: 'Card Payment Terms Value',
    defaultValue: 'Upon Receipt',
  },
  {
    name: 'isAcceptCardDiscount',
    label: 'Accepts Card Discount',
    defaultValue: null,
  },
  {
    name: 'cardDiscountType',
    label: 'Card Discount Type',
    defaultValue: 'Percentage',
  },
  {
    name: 'cardDiscountValue',
    label: 'Card Discount Value',
    defaultValue: '',
  },
  {
    name: 'cardAuthorizationFormFile',
    label: 'Card Authorization Form File',
    defaultValue: '',
  },
  {
    name: 'advancedAcceptanceEnabled',
    label: 'Advanced Acceptance Enabled',
    defaultValue: false,
  },
  {
    name: 'amexProcessingFeeType',
    label: 'Amex Processing Fee Type',
    defaultValue: '$',
  },
  {
    name: 'amexProcessingFeeValue',
    label: 'Amex Processing Fee Value',
    defaultValue: '',
  },
  {
    name: 'amexMinPaymentFeeType',
    label: 'Amex Minimum Payment Fee Type',
    defaultValue: '$',
  },
  {
    name: 'amexMinPaymentFeeValue',
    label: 'Amex Minimum Payment Fee Value',
    defaultValue: '',
  },
  {
    name: 'amexMaxPaymentFeeType',
    label: 'Amex Maximum Payment Fee Type',
    defaultValue: '$',
  },
  {
    name: 'amexMaxPaymentFeeValue',
    label: 'Amex Maximum Payment Fee Value',
    defaultValue: '',
  },
  {
    name: 'amexIncrementalFeeType',
    label: 'Amex Incremental Fee Type',
    defaultValue: '$',
  },
  {
    name: 'amexIncrementalFeeValue',
    label: 'Amex Incremental Fee Value',
    defaultValue: '',
  },
  {
    name: 'amexIncrementalPaymentAmount',
    label: 'Amex Incremental Payment Amount',
    defaultValue: '',
  },
  {
    name: 'visaProcessingFeeType',
    label: 'Visa Processing Fee Type',
    defaultValue: '$',
  },
  {
    name: 'visaProcessingFeeValue',
    label: 'Visa Processing Fee Value',
    defaultValue: '',
  },
  {
    name: 'visaMinPaymentFeeType',
    label: 'Visa Minimum Payment Fee Type',
    defaultValue: '$',
  },
  {
    name: 'visaMinPaymentFeeValue',
    label: 'Visa Minimum Payment Fee Value',
    defaultValue: '',
  },
  {
    name: 'visaMaxPaymentFeeType',
    label: 'Visa Maximum Payment Fee Type',
    defaultValue: '$',
  },
  {
    name: 'visaMaxPaymentFeeValue',
    label: 'Visa Maximum Payment Fee Value',
    defaultValue: '',
  },
  {
    name: 'visaIncrementalFeeType',
    label: 'Visa Incremental Fee Type',
    defaultValue: '$',
  },
  {
    name: 'visaIncrementalFeeValue',
    label: 'Visa Incremental Fee Value',
    defaultValue: '',
  },
  {
    name: 'visaIncrementalPaymentAmount',
    label: 'Visa Incremental Payment Amount',
    defaultValue: '',
  },
  {
    name: 'mastercardProcessingFeeType',
    label: 'Mastercard Processing Fee Type',
    defaultValue: '$',
  },
  {
    name: 'mastercardProcessingFeeValue',
    label: 'Mastercard Processing Fee Value',
    defaultValue: '',
  },
  {
    name: 'mastercardMinPaymentFeeType',
    label: 'Mastercard Minimum Payment Fee Type',
    defaultValue: '$',
  },
  {
    name: 'mastercardMinPaymentFeeValue',
    label: 'Mastercard Minimum Payment Fee Value',
    defaultValue: '',
  },
  {
    name: 'mastercardMaxPaymentFeeType',
    label: 'Mastercard Maximum Payment Fee Type',
    defaultValue: '$',
  },
  {
    name: 'mastercardMaxPaymentFeeValue',
    label: 'Mastercard Maximum Payment Fee Value',
    defaultValue: '',
  },
  {
    name: 'mastercardIncrementalFeeType',
    label: 'Mastercard Incremental Fee Type',
    defaultValue: '$',
  },
  {
    name: 'mastercardIncrementalFeeValue',
    label: 'Mastercard Incremental Fee Value',
    defaultValue: '',
  },
  {
    name: 'mastercardIncrementalPaymentAmount',
    label: 'Mastercard Incremental Payment Amount',
    defaultValue: '',
  },
  { //76
    name: 'discoverProcessingFeeType',
    label: 'Discover Processing Fee Type',
    defaultValue: '$',
  },
  {
    name: 'discoverProcessingFeeValue',
    label: 'Discover Processing Fee Value',
    defaultValue: '',
  },
  {
    name: 'discoverMinPaymentFeeType',
    label: 'Discover Minimum Payment Fee Type',
    defaultValue: '$',
  },
  {
    name: 'discoverMinPaymentFeeValue',
    label: 'Discover Minimum Payment Fee Value',
    defaultValue: '',
  },
  {
    name: 'discoverMaxPaymentFeeType',
    label: 'Discover Maximum Payment Fee Type',
    defaultValue: '$',
  },
  {
    name: 'discoverMaxPaymentFeeValue',
    label: 'Discover Maximum Payment Fee Value',
    defaultValue: '',
  },
  {
    name: 'discoverIncrementalFeeType',
    label: 'Discover Incremental Fee Type',
    defaultValue: '$',
  },
  {
    name: 'discoverIncrementalFeeValue',
    label: 'Discover Incremental Fee Value',
    defaultValue: '',
  },
  {
    name: 'discoverIncrementalPaymentAmount',
    label: 'Discover Incremental Payment Amount',
    defaultValue: '',
  },
  {
    name: 'cardPhoneExtension',
    label: 'Card Phone Extension',
    defaultValue: '',
  },
  {
    name: 'isAcceptAcceptancePerCard',
    label: 'Accepts Acceptance Per Card',
    defaultValue: false
  },
  {
    name: 'amexSecondProcessingFeeType',
    label: 'Amex Second Processing Fee Type',
    defaultValue: '$'
  },
  {
    name: 'amexSecondProcessingFeeValue',
    label: 'Amex Second Processing Fee Value',
    defaultValue: ''
  },
  {
    name: 'visaSecondProcessingFeeType',
    label: 'Visa Second Processing Fee Type',
    defaultValue: '$'
  },
  {
    name: 'visaSecondProcessingFeeValue',
    label: 'Visa Second Processing Fee Value',
    defaultValue: ''
  },
  {
    name: 'mastercardSecondProcessingFeeType',
    label: 'Master Second Processing Fee Type',
    defaultValue: '$'
  },
  {
    name: 'mastercardSecondProcessingFeeValue',
    label: 'Master Second Processing Fee Value',
    defaultValue: ''
  },
  {
    name: 'discoverSecondProcessingFeeType',
    label: 'Discover Second Processing Fee Type',
    defaultValue: '$'
  },
  {
    name: 'discoverSecondProcessingFeeValue',
    label: 'Discover Second Processing Fee Value',
    defaultValue: ''
  },
  {
    name: 'isAcceptProductSpecific',
    label: 'Accepts Card Product Specific',
    defaultValue: null
  },
  {
    name: 'productSpecificOptions',
    label: 'Product Specific Options',
    defaultValue: []
  },
  {
    name: 'isAcceptPOTSPhone',
    label: 'Accepts POTS Phone',
    defaultValue: false
  },
  {
    name: 'isAcceptIVRPhone',
    label: 'Accepts IVR Phone',
    defaultValue: false
  },
  {
    name: 'cardPaymentIVRPhone',
    label: 'IVR Phone',
    defaultValue: ''
  },
  {
    name: 'isAcceptAmexVariableFee',
    label: 'Accepts Amex Variable Fee',
    defaultValue: null
  },
  {
    name: 'isAcceptVisaVariableFee',
    label: 'Accepts Visa variable Fee',
    defaultValue: null
  },
  {
    name: 'isAcceptMasterCardVariableFee',
    label: 'Accepts MasterCard Variable Fee',
    defaultValue: null
  },
  {
    name: 'emailRemitRequirements',
    label: 'Product Specific Options',
    defaultValue: []
  },
  {
    name: 'phoneRemitRequirements',
    label: 'Product Specific Options',
    defaultValue: []
  },
  {
    name: 'faxRemitRequirements',
    label: 'Product Specific Options',
    defaultValue: []
  },
  {
    name: 'onlineRemitRequirements',
    label: 'Product Specific Options',
    defaultValue: []
  },
  {
    name: 'posRemitRequirements',
    label: 'Product Specific Options',
    defaultValue: []
  },
  {
    name: 'isAcceptAmexCardConditions',
    label: 'Accepts Amex Card Conditions',
    defaultValue: null
  },
  {
    name: 'isAcceptVisaCardConditions',
    label: 'Accepts Visa Card Conditions',
    defaultValue: null
  },
  {
    name: 'isAcceptMastercardCardConditions',
    label: 'Accepts Mastercard Card Conditions',
    defaultValue: null
  }
]

export const createSupplierAchColumns = [
  {
    label: 'Do they accept ACH based payments?',
    name: 'isAcceptAchPayments',
    defaultValue: null,
  },
  {
    label: 'Bank Account Number',
    name: 'bankAccountNumber',
    defaultValue: null,
  },
  {
    label: 'Bank Routing Number',
    name: 'bankRoutingNumber',
    defaultValue: null,
  },
  {
    label: 'ACH Instructions',
    name: 'achInstructions',
    defaultValue: null,
  },
  {
    label: 'Email For payment notifications',
    name: 'emailAch',
    defaultValue: null,
  },
  {
    label: 'Bank Name',
    name: 'bankName',
    defaultValue: null,
  },
  {
    label: 'Is ACH Paid Through Portal?',
    name: 'isAchThroughPortal',
    defaultValue: null,
  },
  {
    label: 'ACH Portal URL',
    name: 'achPortalURL',
    defaultValue: null,
  }
]

export const createSupplierCheckColumns = [
  {
    label: 'Do they accept Check payments?',
    name: 'isAcceptCheckPayments',
    defaultValue: null,
  },
  {
    label: 'Check Remittance Address matches Vendor Address?',
    name: 'isAcceptPaymentAddressFromCompanyAddress',
    defaultValue: null,
  },
  {
    label: 'Check Address Line 1',
    name: 'checkAddress1',
    defaultValue: null,
  },
  {
    label: 'Check Address Line 2',
    name: 'checkAddress2',
    defaultValue: null,
  },
  {
    label: 'Check City',
    name: 'checkCity',
    defaultValue: null,
  },
  {
    label: 'Check State',
    name: 'checkState',
    defaultValue: null,
  },
  {
    label: 'Check Zip',
    name: 'checkZip',
    defaultValue: null,
  },
  {
    label: 'Check Country',
    name: 'checkCountry',
    defaultValue: null,
  },
  {
    label: 'Cash Payment Terms',
    name: 'isAcceptCashPaymentTerms',
    defaultValue: null,
  },
  {
    label: 'Cash Payment Terms Value',
    name: 'cashPaymentTermsValue',
    defaultValue: 'Upon Receipt',
  },
  {
    label: 'Accepts Cash Discount',
    name: 'isAcceptCashDiscount',
    defaultValue: null,
  },
  {
    name: 'cashDiscountType',
    label: 'Cash Discount Type',
    defaultValue: 'Percentage',
  },
  {
    name: 'cashDiscountValue',
    label: 'Cash Discount Value',
    defaultValue: '',
  },
]

export const listExportColumns = [
  { label: 'Data Source', name: 'dataSource' },
  { label: 'Is Matched', name: 'isMatched' },
  { label: 'QA Status', name: 'qaStatus' },
  { label: 'Master QA Status', name: 'masterQaStatus' },
  { label: 'Match Status', name: 'matchStatus' },
  { label: 'Vendor Name', name: 'suppliername' },
  { label: 'ERP Vendor Id', name: 'erpVendorId' },
  { label: 'Annualized Spend', name: 'annualizedSpend' },
  { label: 'Address1', name: 'address1' },
  { label: 'Address2', name: 'address2' },
  { label: 'City', name: 'city' },
  { label: 'State', name: 'state' },
  { label: 'Zip', name: 'zip' },
  { label: 'Url', name: 'url' },
  { label: 'Partner Supplier Id', name: 'partnerSupplierId' },
  { label: 'Account Number', name: 'accountNumber' },
  { label: 'Contact Name', name: 'contactNameOld' },
  { label: 'Contact Phone', name: 'phone' },
  { label: 'Contact Email', name: 'email' },
  { label: 'Unsuccessful Enablement Reason', name: 'unSuccessfulEnablementReason' },
  { label: 'Matched Vendor ID', name: 'matchedVendorId' },
  { label: 'Matched Vendor', name: 'matchedVendor' },
  { label: 'Matched Address1', name: 'matchedAddress1' },
  { label: 'Matched Address2', name: 'matchedAddress2' },
  { label: 'Matched City', name: 'matchedCity' },
  { label: 'Matched State', name: 'matchedState' },
  { label: 'Matched Zip', name: 'matchedZip' },
  { label: 'Matched Phone', name: 'matchedPhone' },
  { label: 'Matched Email', name: 'matchedEmail' },
  { label: 'Matched Generic Url', name: 'matchedGenericUrl' },
  { label: 'Vendor Acceptance Information', name: 'acceptanceInformation' },
  { label: 'Conditions for review', name: 'reviewConditions' },
  { label: 'Cardable', name: 'cardable' },
  { label: 'Accepts Amex', name: 'isAcceptAmericanExpress' },
  { label: 'Accepts Amex Variable Fee', name: 'isAcceptAmexVariableFee' },
  { label: 'Accepts Visa', name: 'isAcceptVisa' },
  { label: 'Accepts Visa Variable Fee', name: 'isAcceptVisaVariableFee' },
  { label: 'Accepts MasterCard', name: 'isAcceptMasterCard' },
  { label: 'Accepts MasterCard Variable Fee', name: 'isAcceptMasterCardVariableFee' },
  { label: 'Globally Acceptance', name: 'isAcceptGlobalAcceptance' },
  { label: 'Remit Phone', name: 'cardPaymentByPhoneValue' },
  { label: 'IVR', name: 'IVR' },
  { label: 'Remit Fax', name: 'cardPaymentByFaxValue' },
  { label: 'Remit Email', name: 'remitEmail' },
  { label: 'Portal', name: 'portalUrl' },
  { label: '3rd Party Portal', name: 'thirdPartyPortalUrl' },
  { label: 'Point Of Sale', name: 'isAcceptPointOfSalePortal' },
  { label: 'Accepts ACH', name: 'isAcceptAchPayments' },
  { label: 'Accepts Checks', name: 'isAcceptCheckPayments' },
  { label: 'Last Called Date', name: 'lastCalledDate' },
  { label: 'Last Acceptance Date', name: 'lastAcceptanceDate' },
  { label: 'Employer Id Number', name: 'employerIdNumber' },
  { label: 'Master Card Processing Fee', name: 'mastercardProcessingFee' },
  { label: 'Master Credit Card Minimum and Maximum Payment', name: 'masterCreditCardMinimumAndMaximumPayment' },
  { label: 'AMEX Processing Fee', name: "amexProcessingFeeValue" },
  { label: 'Amex Credit Card Minimum and Maximum Payment', name: 'amexCreditCardMinimumAndMaximumPayment' },
  { label: 'Visa Processing Fee', name: "visaProcessingFeeValue" },
  { label: 'Visa Credit Card Minimum and Maximum Payment', name: 'visaCreditCardMinimumAndMaximumPayment' },
  { label: 'Qa Time', name: 'QaTime' },
  { label: 'Last Settled Payment Date', name: 'lastSettledPaymentDate' },
  { label: 'Last Enablement Date', name: 'lastEnablementDate' },
  { label: 'Calling Campaign Status', name: 'callingCampaignStatus' }
]

export const supplierMatchColumns = [
  { label: 'Matched Status', name: 'isMatched' },
  { label: 'Vendor Name Provided', name: 'suppliername' },
  { label: 'Vendor ID Provided', name: 'erpVendorId' },
  { label: 'Spend Provided', name: 'annualizedSpend' },
  { label: 'Address Provided', name: 'fullAddress' },
  { label: 'Phone Provided', name: 'phone' },
  { label: 'Email Provided', name: 'email' },
  { label: 'Matched Master Supplier Id', name: 'matchedMasterSupplierId' },
  { label: 'Matched Master Supplier Name', name: 'matchedVendor' },
  { label: 'Matched Full Address', name: 'matchedFullAddress' },
  { label: 'Vendor Acceptance Information', name: 'acceptanceInformation' },
  { label: 'Conditions for review', name: 'reviewConditions' },
  { label: 'Accepts Amex', name: 'isAcceptAmericanExpress' },
  { label: 'Accepts Visa', name: 'isAcceptMasterCard' },
  { label: 'Accepts MasterCard', name: 'isAcceptVisa' },
  { label: 'Remit Phone', name: 'cardPaymentByPhoneValue' },
  { label: 'CC Remit Email', name: 'remitEmail' },
  { label: 'Portal', name: 'portalUrl' },
  { label: 'Last Settled Payment Date', name: 'lastSettledPaymentDate' },
  { label: 'Last Enablement Date', name: 'lastEnablementDate' },
  { label: 'Calling Campaign Status', name: 'callingCampaignStatus' }
]

export const paymentOptimizationColumns = [
  { label: 'Is Matched', name: 'isMatched' },
  { label: 'Master QA Status', name: 'masterQaStatus' },
  { label: 'Match QA Status', name: 'matchQaStatus' },
  { label: 'Campaign Qa Status', name: 'campaignQaStatus' },
  { label: 'In Ricochet Supplier Network', name: 'suppliername' },
  { label: 'Vendor ID Provided', name: 'erpVendorId' },
  { label: 'Spend Provided', name: 'annualizedSpend' },
  { label: 'Address Provided', name: 'fullAddress' },
  { label: 'Phone Provided', name: 'phone' },
  { label: 'Email Provided', name: 'email' },
  { label: 'Matched Master Supplier Id', name: 'matchedMasterSupplierId' },
  { label: 'Matched Master Supplier Name', name: 'matchedMasterSupplierName' },
  { label: 'Matched Full Address', name: 'matchedFullAddress' },
  { label: 'Unsuccessful Enablement Reason', name: 'unSuccessfulEnablementReason' },
  { label: 'Global Acceptance', name: 'isAcceptGlobalAcceptance' },
  { label: 'Vendor Acceptance Information', name: 'acceptanceInformation' },
  { label: 'Conditions for review', name: 'reviewConditions' },
  { label: 'Current Payment Method', name: 'currentPaymentMethod' },
  { label: 'Payment Count', name: 'paymentCount' },
  { label: 'Selective Acceptance', name: 'selectiveAcceptance' }, //new logic
  { label: 'Suggested Customer Next Steps', name: 'suggestedCustomer' }, //new logic
  { label: 'Email Remit', name: 'remitEmail' },
  { label: 'Phone Remit', name: 'cardPaymentByPhoneValue' },
  { label: 'Fax Remit', name: 'cardPaymentByFaxValue' },
  { label: 'Online Remit Portal', name: 'isAcceptCardPaymentByOnlinePortal' },
  { label: 'Portal URL', name: 'portalUrl' },
  { label: 'POS Remit', name: 'isOnlyAcceptCardAsPos' },
  { label: 'Accepts Amex Variable Fee', name: 'isAcceptAmexVariableFee' },
  { label: 'Accepts Visa Variable Fee', name: 'isAcceptVisaVariableFee' },
  { label: 'Accepts MasterCard Variable Fee', name: 'isAcceptMasterCardVariableFee' },
  { label: 'Last Called Date', name: 'lastCalledDate' },
  { label: 'Master Card Processing Fee', name: 'mastercardProcessingFee' },
  { label: 'Master Credit Card Minimum and Maximum Payment', name: 'masterCreditCardMinimumAndMaximumPayment' },
  { label: 'AMEX Processing Fee', name: "amexProcessingFeeValue" },
  { label: 'Amex Credit Card Minimum and Maximum Payment', name: 'amexCreditCardMinimumAndMaximumPayment' },
  { label: 'Visa Processing Fee', name: "visaProcessingFeeValue" },
  { label: 'Visa Credit Card Minimum and Maximum Payment', name: 'visaCreditCardMinimumAndMaximumPayment' },
  { label: 'Check Address', name: 'checkPaymentAddress' }, ,
  { label: 'ACH Remit Email', name: 'achRemitEmail' },
  { label: 'ACH Account Number', name: 'achAccountNumber' },
  { label: 'ACH Routing Number', name: 'achRoutingNumber' },
  { label: 'Last Settled Payment Date', name: 'lastSettledPaymentDate' },
  { label: 'Last Enablement Date', name: 'lastEnablementDate' },
  { label: 'Calling Campaign Status', name: 'callingCampaignStatus' }
]

export const rwConfigurationColumns = [
  { label: 'Vendor Name Provided', name: 'suppliername' },
  { label: 'Vendor ID Provided', name: 'erpVendorId' },
  { label: 'Spend Provided', name: 'annualizedSpend' },
  { label: 'Address Provided', name: 'fullAddress' },
  { label: 'Phone Provided', name: 'phone' },
  { label: 'Email Provided', name: 'email' },
  { label: 'Vendor Acceptance Information', name: 'acceptanceInformation' },
  { label: 'Conditions for review', name: 'reviewConditions' },
  { label: 'Accepts Amex', name: 'isAcceptAmericanExpress' },
  { label: 'Accepts Visa', name: 'isAcceptVisa' },
  { label: 'Accepts MasterCard', name: 'isAcceptMasterCard' },
  { label: 'Remit Email', name: 'allremitEmail' },
  { label: 'Remit Phone', name: 'cardPaymentByPhoneValue' },
  { label: 'Remit Portal', name: 'portalUrl' },
  { label: 'Remit Fax', name: 'cardPaymentByFaxValue' },
  { label: 'Check Address', name: 'checkPaymentAddress' },
  { label: 'ACH Remit Email', name: 'achRemitEmail' },
  { label: 'ACH Account Number', name: 'achAccountNumber' },
  { label: 'ACH Routing Number', name: 'achRoutingNumber' },
  { label: 'Proxy Payable', name: 'proxyPayable' },
  // { label: 'Card Acceptance Notes', name: 'cardAcceptanceNotes' },
  { label: 'Match QA Status', name: 'matchQaStatus' },
  { label: 'Campaign Qa Status', name: 'campaignQaStatus' },
  { label: 'Calling Campaign Status', name: 'callingCampaignStatus' }
]